export default __webpack_public_path__ + "static/media/coin.a3eff4a8.gif";